import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Card } from '@/components/Card/card';
import { HStack } from '@/components/Layout';
import { Loader } from '@/components/Loading';
import { cn } from '@/lib/cn';
import { featureFlags } from '@/lib/env';
import { InHousePackageSidebar as Sidebar } from './-components/Sidebar';
import { useInHousePackageSidebar } from './-components/Sidebar/hooks';
import { listInHousePackages } from './-query/api';

/**
 * テナント専用パッケージ（In-House packages）一覧のレイアウト。
 * サイドバー（セルフレポート / 申請）＋ 詳細（Outlet）で構成する。
 * 個別パッケージの表示は `/it-operation-core/in-house-packages/$packageId` で行う。
 */
export const Route = createFileRoute('/_staff/it-operation-core/_root/in-house-packages')({
  beforeLoad: () => {
    if (!featureFlags.check('ENABLE_IN_HOUSE_OPERATION_PACKAGE')) {
      throw redirect({
        to: '/it-operation-core/packages'
      });
    }
  },
  loader: () => listInHousePackages(),
  component: RouteComponent
});
function RouteComponent() {
  const packages = Route.useLoaderData();
  const sidebar = useInHousePackageSidebar({
    packages
  });
  return <HStack className="h-full overflow-y-hidden">
      <Suspense fallback={<Loader size="size-6" />}>
        <Sidebar {...sidebar} />
      </Suspense>
      <HStack className="min-w-0 flex-1 p-6 overflow-x-auto">
        <Card className={cn('w-full h-full rounded-md overflow-hidden', 'outline-neutral-muted-border outline-solid outline-1')}>
          <Outlet />
        </Card>
      </HStack>
    </HStack>;
}